<script>
import Detail from "./detail";
import Multiselect from "vue-multiselect";
import { isProfessionalActive, professionalStatusLabel } from "@/helpers/professionalStatus";
import { createProfessionalFilters, matchesProfessionalFilters } from "./professionalFilters";

export default {
  props: {
    currentEmpresa: { type: Object, required: true },
    professionals: { type: Array, required: true },
    specialties: { type: Array, default: () => [] },
    hide: { type: Boolean, required: true }
  },
  components: { Detail, Multiselect },
  data() {
    return {
      titleBody: 'Listagem dos Pacientes',
      currentProfessional: undefined,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filters: createProfessionalFilters(),
      statusOptions: [
        { value: 'all', text: 'Todos' },
        { value: 'active', text: 'Ativos' },
        { value: 'inactive', text: 'Inativos' },
      ],
      sortBy: "id",
      sortDesc: false,
      fields: [
        { label: "ID", key: "id", sortable: true, tdClass: 'text-center', thClass: 'text-center' },
        { label: 'Nome', key: 'name', sortable: true, thClass: 'text-center' },
        { label: "E-mail", key: "email", sortable: true, thClass: 'text-center' },
        { label: "Celular", key: "contact", sortable: true, tdClass: 'text-right', thClass: 'text-center' },
        { label: "Especialidade", key: "specialty", sortable: true, tdClass: 'text-center', thClass: 'text-center' },
        { label: "Situação", key: "status", sortable: true, tdClass: 'text-center', thClass: 'text-center' },
        { label: "Ações", key: "acoes", sortable: false, tdClass: 'text-center', thClass: 'text-center' }
      ],
      isShow: false,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.filteredProfessionals.length;
    },
    filteredProfessionals() {
      return this.professionals.filter((professional) => (
        matchesProfessionalFilters(professional, this.filters)
      ));
    },
    clonefoot() {
      return this.filteredProfessionals.length > 0;
    },
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.currentPage = 1;
      },
    },
  },
  mounted() {
   // this.$emit('newTitle', this.titleBody);
  },
  created(){
  },
  methods: {
    clearFilters() {
      this.filters = createProfessionalFilters();
    },
    editar(currentProfessional) {
      this.$emit('edit', currentProfessional);
    },
    excluir(professional) {
      this.$emit('doDelete', professional);
    },
    setProfessional(currentProfessional) {
      console.log(currentProfessional);
      this.currentProfessional = currentProfessional;
    },
    view(currentProfessional) {
      this.currentProfessional = currentProfessional;
      this.isShow = true;
    },
    isProfessionalActive,
    professionalStatusLabel,
  },
}
</script>

<template>
<div class="card-body" v-if="hide">
  <div class="border rounded p-3 mt-4 bg-light">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h5 class="mb-0">Filtros de profissionais</h5>
      <b-button variant="outline-secondary" size="sm" @click="clearFilters">
        <i class="ri-filter-off-line mr-1"></i> Limpar filtros
      </b-button>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12 col-md-6 col-lg-4">
        <label for="professional-filter-name">Nome</label>
        <b-form-input
          id="professional-filter-name"
          v-model="filters.name"
          type="search"
          placeholder="Nome do profissional"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-council">Conselho</label>
        <b-form-input
          id="professional-filter-council"
          v-model="filters.council"
          placeholder="Ex.: CRM"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-credential">Credencial</label>
        <b-form-input
          id="professional-filter-credential"
          v-model="filters.credential"
          placeholder="Número"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-status">Situação</label>
        <b-form-select
          id="professional-filter-status"
          v-model="filters.status"
          :options="statusOptions"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-email">E-mail</label>
        <b-form-input
          id="professional-filter-email"
          v-model="filters.email"
          type="search"
          placeholder="E-mail"
        />
      </div>
    </div>
    <div class="form-row">
      <div class="form-group col-sm-12 col-lg-4">
        <label for="professional-filter-specialties">Especialidades</label>
        <Multiselect
          id="professional-filter-specialties"
          v-model="filters.specialties"
          :options="specialties"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          label="name"
          track-by="id"
          placeholder="Todas as especialidades"
          select-label="Selecionar"
          selected-label="Selecionada"
          deselect-label="Remover"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-birth-from">Nascimento de</label>
        <b-form-input
          id="professional-filter-birth-from"
          v-model="filters.birthDateFrom"
          type="date"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-birth-to">Nascimento até</label>
        <b-form-input
          id="professional-filter-birth-to"
          v-model="filters.birthDateTo"
          type="date"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-created-from">Cadastro de</label>
        <b-form-input
          id="professional-filter-created-from"
          v-model="filters.createdAtFrom"
          type="date"
        />
      </div>
      <div class="form-group col-sm-6 col-lg-2">
        <label for="professional-filter-created-to">Cadastro até</label>
        <b-form-input
          id="professional-filter-created-to"
          v-model="filters.createdAtTo"
          type="date"
        />
      </div>
    </div>
    <div class="text-muted small">
      {{ filteredProfessionals.length }} profissional(is) encontrado(s)
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-12">
      <label class="d-inline-flex align-items-center">
        Exibir&nbsp;
        <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;registros
      </label>
    </div>
  </div>
   <!-- Start Table -->
   <div class="row mt-4">
    <div v-if="hide" class="table-responsive mb-0">
      <b-table
       :items="filteredProfessionals"
       :fields="fields"
       responsive="sm"
       :per-page="perPage"
       :current-page="currentPage"
       :sort-by.sync="sortBy"
       :sort-desc.sync="sortDesc"

       :hover=true
       :foot-clone=clonefoot
      >
        <template #cell(status)="row">
          <b-badge :variant="isProfessionalActive(row.item) ? 'success' : 'secondary'">
            {{ professionalStatusLabel(row.item) }}
          </b-badge>
        </template>
        <template #cell(specialty)="row">
          <b-badge v-for="specialty in row.item.specialty" :key="specialty.id" variant="info" class="ml-1">{{ specialty.name }}</b-badge>
        </template>
        <template #cell(acoes)="row">
          <!-- `data.value` is the value after formatted by the Formatter -->
          <b-dropdown v-bind:id="'dropdown-'+ row.item.id" class="m-md-2">
            <template #button-content>
              <i data-v-6289eca4="" class="bx ri-menu-line"></i>
            </template>
            <b-dropdown-item
             v-b-modal.modal-profissional
             @click="setProfessional(row.item)"
            >
              <i class="bx ri-file-search-line"></i> Visualizar
            </b-dropdown-item>
            <b-dropdown-item @click="editar(row.item)"><i class="bx ri-edit-2-line"></i> Alterar</b-dropdown-item>
            <b-dropdown-item
             @click="excluir(row.item)"
            >
              <i class="bx ri-eraser-fill"></i> Excluir
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>
    </div>
   </div>
   <!-- End Table -->
   <!-- Start Pagination -->
  <div v-if="hide" class="row mt-4">
    <div class="col">
      <div class="dataTables_paginate paging_simple_numbers float-right">
        <ul class="pagination pagination-rounded mb-0">
          <!-- pagination -->
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
        </ul>
      </div>
    </div>
  </div>
  <!-- End Pagination -->
  <!-- Start Modal View -->
  <b-modal
    no-close-on-backdrop
    id="modal-profissional"
    title="Visualizar Profissional"
    title-class="font-18"
    ok-only
    size="xl"
    dialog-class="modal-profissional-detail-wide"
  >
    <Detail :currentProfessional="currentProfessional"/>
  </b-modal>
  <!-- End Modal View -->
</div>
</template>

<style>
/* Modal no body: classe exclusiva para não afetar outros modais */
.modal-profissional-detail-wide {
  max-width: min(96vw, 1240px) !important;
  margin-left: auto;
  margin-right: auto;
}
@media (min-width: 1600px) {
  .modal-profissional-detail-wide {
    max-width: 1320px !important;
  }
}
</style>